export enum ParameterType {
  String = 'string',
  Integer = 'integer',
  Decimal = 'decimal',
  Time = 'time',
  Date = 'date',
}
